import { setAddress } from "$store/sdk/shipping.ts";
import { useEffect } from "preact/compat";
import { invoke } from "site/runtime.ts";
import { useCart } from "apps/vtex/hooks/useCart.ts";

interface Props {
  modalId: string;
}

const setup = ({ modalId }: Props) => {
  const root = document.getElementById(`modal-${modalId}`);
  const form = root?.querySelector("form");
  const input = form?.querySelector("input");
  const { cart } = useCart();

  if (!root || !form || !input) {
    console.error(
      "Missing necessary tab attributes. It will not work as intended. Necessary elements:",
      { root, form },
    );
    return;
  }

  const onSubmit = async (event: SubmitEvent) => {
    event.preventDefault();

    const postalCode = input.value;

    if (!postalCode || !postalCode.toString().match(/\d{5}-?\d{3}/)) {
      form.setAttribute("data-error", "true");
      input!.placeholder = "Digite um CEP válido";
      input!.value = "";
      input!.addEventListener(
        "input",
        () => form.removeAttribute("data-error"),
        { once: true },
      );

      return;
    }

    try {
      await invoke["site"].actions
        .updateShippingData({
          country: cart.value?.storePreferencesData.countryCode || "BRA",
          postalCode,
        });

      await setAddress(postalCode);

      const modalVisibilityCheckbox = document
        .getElementById(modalId) as HTMLInputElement | null;

      if (modalVisibilityCheckbox) modalVisibilityCheckbox.checked = false;
    } catch (error) {
      console.error(error);
    }
  };

  form.addEventListener("submit", onSubmit);

  return () => {
    form.removeEventListener("submit", onSubmit);
  };
};

export default function LocationJS({ modalId }: Props) {
  useEffect(() => setup({ modalId }), [modalId]);
  return null;
}
